<template>
  <div
    v-if="loadingEnterprise"
    class="text-center"
  >
    <v-progress-circular
      :size="70"
      :width="7"
      :color="Color"
      indeterminate
    />
  </div>
  <v-content
    v-else
    style="padding: 0px"
    :style="{ 'border-radius': borderRadius, 'background-color': BGColor, 'height' : colapse ? '600px' : ''}"
  >
    <div
      v-if="!isSimulation"
      style="position:fixed;width:100%;height: calc(100vh);z-index:0"
      :style="{ 'border-radius': borderRadius, 'background-color': BGColor}"
    >
    </div>
    <div
      v-if="isCollapse || isSimulation"
      @click="handleOpenMenuOnTouchBackground"
    >
      <background
        v-if="isCollapse || isSimulation"
      />
    </div>
    <v-expansion-panels
      v-model="mainPanel"
      multiple
      :disabled="!isMenu && isSimulation"
      style="z-index:1"
    >
      <v-expansion-panel>
        <main-menu-header
          :onAdd="onAdd"
          :onClickMainMenu="handleClickMainMenu"
        />
        <dish-orders-cart
          v-if="config"
          :config="config"
          :locale="locale"
        />
        <v-expansion-panel-content
          ref="expPanel"
          v-if="menus"
          style="padding: 0 0 0 0 !important;"
          :style="{ 'background-color': BGColor }"
        >
          <custom-menu 
            v-if="menus"
            :data="isSimulation ? menus : menus.filter(x => x.IsActive && !x.HideMobile)"
            :onEdit="onEdit"
            :expandFirstElement="expandFirstElement"
          />
          <back-button :isMain="true" :isMenu="true" v-if="!isSimulation"/>
          <custom-URL-back :isMain="true" :isMenu="true" v-if="!isSimulation"/>
          <div
            v-if="!isSimulation"
            style="padding: 50px 0 50px 0;"
            :style="{ 'background-color': BGColor }"
          >
          <center style="color: #FFFFFF33;">{{info}}</center>
          </div>
        </v-expansion-panel-content>
        <!-- loading -->
        <v-expansion-panel-content
          v-else
          ref="expPanel"
          style="padding: 20px !important"
          :style="{ 'background-color': BGColor }"
        >
          <div class="text-center">
            <v-progress-circular
              :size="70"
              :width="7"
              :color="Color"
              indeterminate
            />
          </div>
          <!-- <v-progress-linear
            :color="BGColor"
            indeterminate
            rounded
            height="6"
          /> -->
        </v-expansion-panel-content>
      </v-expansion-panel>
      <custom-language v-if="isCollapse" />
      <back-button v-if="isCollapse" :isMenu="true" style="width: 100%;"/>
      <custom-URL-back v-if="isCollapse" :isMenu="true" style="width: 100%;"/>
    </v-expansion-panels>
    <welcome-form 
      v-if="!isSimulation && config && config.WelcomeForm" 
      :workspaceID="config.ID"
      :locale="locale"
      :color="BGColorSecundary"
      :logo="Logo"
      :config="config"
    />
    <!-- <back-button :isMenu="true" /> -->
    <v-btn
      id="btnBackToTop"
      color="rgba(0, 0, 0, 0.3)"
      fixed
      fab
      dark
      bottom
      right
      @click.stop.prevent="handleBackToTop"
    >
      <v-icon>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
  import { mapState } from 'vuex'
  import BackButton from '@/components/BackButton'
  import CustomURLBack from '@/components/CustomURLBack'
  import MainMenuHeader from './MainMenuHeader'
  import Background from './Background'
  import CustomLanguage from './CustomLanguage'
  import CustomMenu from './customMenu/Index'
  import WelcomeForm from './welcomeForm/Index'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import constants from '@/constants'
  import DishOrdersCart from '@/views/private/dishOrders/dishOrdersCart/Index'

  window.onscroll = function () { scrollFunction() }
  function scrollFunction () {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      if (document.getElementById('btnBackToTop')) document.getElementById('btnBackToTop').style.display = 'block'
    } else {
      if (document.getElementById('btnBackToTop')) document.getElementById('btnBackToTop').style.display = 'none'
    }
  }

  export default {
    components: {
      MainMenuHeader,
      CustomMenu,
      Background,
      CustomLanguage,
      BackButton,
      CustomURLBack,
      DishOrdersCart,
      WelcomeForm,
    },
    props: {
      ID: {
        type: String,
        required: false,
        default: null
      },
      domain: {
        type: String,
        required: false,
        default: null
      },
      colapse: {
        type: Boolean,
        required: false,
        default: false
      },
      onAdd: {
        type: Function,
        required: false,
        default: null
      },
      onEdit: {
        type:Function,
        required: false,
        default: null
      }
    },
    data: () => ({
      mainPanel: [],
      isCollapse: false,
      loadingEnterprise: true,
      expandFirstElement: false,
    }),
    computed: {
      ...mapState('app',['locale', 'isAdmin', 'authData', 'BGColor', 'Color', 'Logo', 'menus', 'BGColorSecundary']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isCommonMenus () {
        return this.$route.path.split('/')[1] === 'common-menus' ? true : false
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      info () {
        return process.env.VUE_APP_INFOSORT
      },
      backDomain () {// es informado cuando viene desde otra app
        return this.$route.query.back && this.$route.query.back !== undefined ? this.$route.query.back : null
      }
    },
    watch:{
      authData (v) {
        this.getMenus()
      },
      $route (to, from){
        if (to.path && to.path !== from.path) {
          if (to.path.length > 0) {
            this.getEnterprise()
            this.getMenus()
          }
        }
      },
      'locale' (v, nv) {
        console.log(v, nv)
        this.handleCheckExpandOnChangeLocale()
      },
    },
    mounted () {
      if (this.backDomain && !this.isSimulation) {
        this.isCollapse = false
        this.mainPanel = [1, 0]
      } else {
        this.isCollapse = this.isSimulation ? this.colapse : true
        this.mainPanel = this.isSimulation && !this.colapse ? [1, 0] : []
      }
          
      this.getEnterprise()
      this.getMenus()
    },
    methods: {
      handleOpenMenuOnTouchBackground () {
        this.mainPanel = [1,0]
        this.handleClickMainMenu()
      },
      handleBackToTop () {
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
        const aux = []
        for (let i = 0; i < this.menus.length; i++) {
          aux.push(false)
        }
        this.expandData = aux
      },
      handleCheckExpandOnChangeLocale () {
        // check is valid
        this.handleOpenMenuOnTouchBackground ()
      },
      handleClickMainMenu () {
        this.isCollapse = this.$refs.expPanel.isActive
      },
      getEnterprise () {
        const auxID = this.ID ? this.ID : this.domain
        if (auxID) {
          const aux = this.$route.query.c ? `?public=true&c=${this.$route.query.c}` : !this.isSimulation ? '?public=true' : ''          
          api.getItem('enterprises', false, auxID.concat(aux)).then(response => {
            this.config = response
            if (!response.ID) {
              // TODO pendiente hacer la validación
              // si es privat
              this.$router.push('/404')
              // window.location.href = '/#/404'
            }
            if (response.TimeZone) this.$store.state.app.TimeZone = response.TimeZone
            this.$store.state.app.dtouchWorkspace = response.ID
            this.$store.state.app.allergenFilters = response.AllergenFilters
            this.$store.state.app.showDishesImage = response.ShowDishesImage
            this.$store.state.app.showDishesAllergens = response.ShowDishesAllergens
            this.expandFirstElementWithoutMainMenu = response.ExpandFirstElementWithoutMainMenu ? true : false
            this.expandFirstElement = response.ExpandFirstElement ? true : false
            if ( this.expandFirstElement || this.expandFirstElementWithoutMainMenu ) {
              if (this.expandFirstElementWithoutMainMenu) {
                this.isCollapse = true
                this.mainPanel = [1,0]
              } else {
                this.isCollapse = false
                this.mainPanel = [1, 0]
              }
            }
            if (!this.isSimulation) document.title = response.Name // se añade esto para que en el title aparezca el nombre del cliente
            // if (this.isCommonMenus){
            //   this.$store.state.app.enterpriseName = 'Menús comunes'
            //   // this.$store.state.app.BGColor = '#56A099'

            //   // this.$store.state.app.BGColorSecundary = '#CCCCCC'
            //   // this.$store.state.app.BGColorContent = '#FFFFFF'
            //   // this.$store.state.app.Color = '#FFFFFF'
            //   // this.$store.state.app.ColorSecundary = '#495057'
            //   // this.$store.state.app.ColorContent = '#495057'
            //   this.$store.state.app.Logo = 'http://dtouch.es/assets/logo_menuscomunes.png'
            //   // this.$store.state.app.Carousel = []
            //   // this.$store.state.app.withGradient = false
            //   // this.$store.state.app.withLine = false

            // } else {
              this.$store.state.app.isMenuLeft = response.IsMenuLeft
              this.$store.state.app.enterpriseName = response.Name
              this.$store.state.app.BGColor = response.BGColor ? response.BGColor : '#56A099'

              this.$store.state.app.btnBackgroundColor = response.BtnBackgroundColor ? response.BtnBackgroundColor : ''
              this.$store.state.app.btnTextColor = response.BtnTextColor ? response.BtnTextColor : ''
              this.$store.state.app.foodDrinkTextColor = response.FoodDrinkTextColor ? response.FoodDrinkTextColor : ''
              this.$store.state.app.foodDrinkBGColor = response.FoodDrinkBGColor ? response.FoodDrinkBGColor : ''

              this.$store.state.app.BGColorSecundary = response.BGColorSecundary ? response.BGColorSecundary : '#CCCCCC'
              this.$store.state.app.BGColorContent = response.BGColorContent  ? response.BGColorContent : '#FFFFFF'
              this.$store.state.app.foodIconRight = response.FoodIconRight

              this.$store.state.app.Color = response.Color ? response.Color : '#495057'
              this.$store.state.app.ColorSecundary = response.ColorSecundary ? response.ColorSecundary : '#495057'
              this.$store.state.app.ColorContent = response.ColorContent ? response.ColorContent : '#495057'
              this.$store.state.app.Logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'
              this.$store.state.app.Carousel = response.Carousel ? response.Carousel.split(',') : []
              this.$store.state.app.withGradient = response.GradientMenu  === 1 ? true : false
              this.$store.state.app.withGradientSubmenu = response.GradientSubmenu === 1 ? true : false
              this.$store.state.app.withLine = response.LineMenu === 1 ? true : false

              this.$store.state.app.GlobalFont = response.GlobalFont
              if (response.Font) this.$store.state.app.Font = response.Font
              if (response.FontSecundary) this.$store.state.app.FontSecundary = response.FontSecundary
              if (response.FontContent) this.$store.state.app.FontContent = response.FontContent

              if (response.FontSize) this.$store.state.app.FontSize = response.FontSize
              if (response.FontSizeSecundary) this.$store.state.app.FontSizeSecundary = response.FontSizeSecundary
              if (response.FontSizeContent) this.$store.state.app.FontSizeContent = response.FontSizeContent

              if (response.TextFormat) this.$store.state.app.TextFormat = response.TextFormat
              if (response.TextFormatSecundary) this.$store.state.app.TextFormatSecundary = response.TextFormatSecundary
              if (response.AuthType) this.$store.state.app.dfileWorkspace = response.DfileWorkspace
            // }
            //             
            // this.$store.state.app.BGColorSecundary = response.BGColorSecundary ? response.BGColorSecundary : '#CCCCCC'
            // this.$store.state.app.BGColorContent = response.BGColorContent  ? response.BGColorContent : '#FFFFFF'
            // this.$store.state.app.Color = response.Color ? response.Color : '#495057'
            // this.$store.state.app.ColorSecundary = response.ColorSecundary ? response.ColorSecundary : '#495057'
            // this.$store.state.app.ColorContent = response.ColorContent ? response.ColorContent : '#495057'
            // this.$store.state.app.Logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'
            // this.$store.state.app.Carousel = response.Carousel ? response.Carousel.split(',') : []
            // this.$store.state.app.withGradient = response.GradientMenu  === 1 ? true : false
            // this.$store.state.app.withLine = response.LineMenu === 1 ? true : false

            // this.$store.state.app.GlobalFont = response.GlobalFont
            // if (response.Font) this.$store.state.app.Font = response.Font
            // if (response.FontSecundary) this.$store.state.app.FontSecundary = response.FontSecundary
            // if (response.FontContent) this.$store.state.app.FontContent = response.FontContent

            // if (response.FontSize) this.$store.state.app.FontSize = response.FontSize
            // if (response.FontSizeSecundary) this.$store.state.app.FontSizeSecundary = response.FontSizeSecundary
            // if (response.FontSizeContent) this.$store.state.app.FontSizeContent = response.FontSizeContent
            
            this.$store.state.app.Languages = response.Languages ? response.Languages.split(',') : ['es']
            this.$store.state.app.DefaultLocale = response.DefaultLocale ? response.DefaultLocale : 'es'
            this.$store.state.app.authType = response.AuthType && response.AuthType.length > 0 ? response.AuthType : 'none'
            this.loadingEnterprise = false
          })
        } else {
          this.$router.push('/404')
        }
      },
      prepareColor (v, v2) {
        return v ? v : v2
      },
      getMenus () {
        if (this.isMenu || !this.isSimulation) {          
          let auxID = this.isCommonMenus ? '0000' : this.ID ? this.ID : this.domain
          // se añade el id de usuario para los menús comunes poder filtrar por ellos
          auxID = `${auxID}/${this.isAdmin ? '' : this.$store.state.app.userID}`
          if (auxID) {
            api.getAll(`menus`, false, null, null, null, auxID).then(response => {
              response = response.map(item => {
                //tmp
                item.BGColor = this.prepareColor(item.BGColor, this.config.BGColor)
                item.TextColor = this.prepareColor(item.TextColor, this.config.Color)
                item.BGColorContent = this.prepareColor(item.BGColorContent, this.config.BGColorContent)
                item.FontSize = this.config.FontSize
                item.Font = this.config.Font
                item.TextFormat = this.config.TextFormat
                //tmp
                if (item.Menus) {
                  item.Menus = item.Menus.map (submenu => {
                    // tmp
                    submenu.BGColor = this.prepareColor(submenu.BGColor, this.config.BGColorSecundary)
                    submenu.TextColor = this.prepareColor(submenu.TextColor, this.config.ColorSecundary)
                    submenu.BGColorContent = this.prepareColor(submenu.BGColorContent, this.config.BGColorContent)
                    submenu.FontSize = this.config.FontSizeSecundary
                    submenu.Font = this.config.FontSecundary
                    submenu.TextFormat = this.config.TextFormatSecundary
                    //tmp
                    submenu.Availability = utils.checkAvailabilityStatus(submenu.Availability)
                    if (submenu.Common && submenu.Availability.status) {
                      const {date, time} = submenu.Availability.status
                        submenu.IsActive = date && time ? true : false
                    }
                    return submenu
                  })
                  if (!this.isSimulation) {
                    item.Menus = item.Menus.filter(x => x.Availability.status.time && x.Availability.status.date)
                  }
                }
                item.Availability = utils.checkAvailabilityStatus(item.Availability)
                if (item.Common && item.Availability.status) {
                  const {date, time} = item.Availability.status
                    item.IsActive = date && time ? true : false
                }
                return item
              })
              if (!this.isSimulation) response = response.filter(x => x.Availability && x.Availability.status.time && x.Availability.status.date)
              if (!this.isSimulation && this.$store.state.app.authType !== 'none' && !this.$store.state.app.authData) {                
                // this.$store.state.app.menus = response.filter(x => !x.Private && x.IsActive)
                this.$store.state.app.menus = response.filter(x => !x.Private)
              } else {
                this.$store.state.app.menus = response
              }              
            })
            // this.$store.state.app.menus = []
          } else {
            this.$router.push('/404')
          }
        } else {
          this.$store.state.app.menus = [
            {
              ID: '1',
              Name: { es: 'Menú 1', en: 'Menu 1' },
              IsActive: true,
              Availability: {
                status: {
                  time: true
                }
              },
              Common: 0,
              Menus: [
                {
                  ID: '3',
                  Name: { es: 'Submenú 1', en: 'Submenu 1' },
                  IsActive: true,
                  Availability: {
                    status: {
                      time: true
                    }
                  },
                  Type: 0,
                  Common: 0,
                }
              ]
            },
            {
              ID: '2',
              Name: { es: 'Menú 2', en: 'Menu 2' },
              IsActive: true,
              Availability: {
                status: {
                  time: true
                }
              },
              Type: 0,
              Common: 0,
            }
          ]
        }
      }
    }
  }
</script>
<style>
  #btnBackToTop {
    display: none;
  }
  .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
  .v-expansion-panel {
    margin: 0 !important;
  }
  .v-expansion-panels:not(.v-expansion-panels--accordion) > .v-expansion-panel--next-active .v-expansion-panel-header {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
</style>
